import React from "react";
import PropTypes from "prop-types";

function Ribbon({ content, variant, size }) {
  return (
    <div id="ribbon-container">
      <div className={`ribbon ${variant ? variant : ""} ${size ? size : ""}`}>
        <p className="ribbon-content">{content}</p>
      </div>
    </div>
  );
}

Ribbon.propTypes = {
  content: PropTypes.string.isRequired,
  variant: PropTypes.string,
  size: PropTypes.string,
};

export default Ribbon;
